/* eslint-disable react-hooks/exhaustive-deps */

import { TableCell, TableRow } from "@material-ui/core";
import {
  InputTextMaster,
  MasterButton,
  Modal,
  TableWrapper,
} from "App/Component/ui";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { DISABLED_BUTTON_SUBMIT, instance2 } from "App/constants";
import { useDatatables } from "App/hooks";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import React, { useState, useEffect } from "react";
import { LIST_URL_MASTER } from "utils/masters";
import { getKetersediaanAplicare } from "./helpers";

function ModalKetersediaanAplicare({ setShowModal, id }) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    setNewData();
  }, []);

  const setNewData = async () => {
    const response = await getKetersediaanAplicare(id);
    if (response.state) {
      setRows(response.data);
    } else {
      setRows([]);
    }
  };

  return (
    <Modal title='Ketersediaan Aplicare' width={"70%"} show={setShowModal}>
      <TableListKetersediaanAplicare rows={rows} />
    </Modal>
  );
}

const TableListKetersediaanAplicare = ({ rows }) => {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name"],
  });

  return (
    <TableWrapper
      title='Daftar Ketersediaan'
      setQ={setQ}
      withAddButton={false}
      withExportButton={false}
      order={order}
      orderBy={orderBy}
      handleRequestSort={handleRequestSort}
      length={length}
      rows={rows}
      headCells={headCells}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}>
      {stableSort(data, getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, index) => {
          return <TableRowKetersediaanAplicare index={index} row={row} />;
        })}
    </TableWrapper>
  );
};

const btnUpdate = {
  label: "UPDATE",
  color: "green",
  state: false,
};
const TableRowKetersediaanAplicare = ({ index, row }) => {
  const [disabled, setDisabled] = useState(btnUpdate);
  const [formData, setFormData] = useState({
    kapasitas: "",
    tersedia: "",
  });

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const handleClickUpdate = async (row) => {
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      const response = await instance2.post(
        LIST_URL_MASTER.golkelas_aplicares.update_ketersediaan_aplicare,
        {
          kode_kelas: row.kode_kelas,
          kode_ruang: row.kode,
          nama_ruang: row.name,
          kapasitas: isNull(formData.kapasitas)
            ? row.jumlah_bed
            : formData.kapasitas,
          tersedia: isNull(formData.tersedia)
            ? row.bed_tersedia
            : formData.tersedia,
        }
      );

      if (response.data.status === 200) {
        setDisabled(btnUpdate);
        defaultToastSuccess(response.data.message);
      } else {
        setDisabled(btnUpdate);
        defaultToastError(response.data.message);
      }
    } catch (error) {
      setDisabled(btnUpdate);
      defaultToastError(error?.response?.data?.message);
    }
  };

  return (
    <>
      <TableRow
        hover
        tabIndex={-1}
        key={index}
        style={{
          backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
        }}>
        <TableCell component='th' scope='row' padding='none' align='center'>
          {index + 1}
        </TableCell>
        <TableCell align='left' width={"10%"}>
          {row?.kode}
        </TableCell>
        <TableCell align='left'>{row?.name}</TableCell>
        <TableCell align='left'>
          <InputTextMaster
            name={`kapasitas-${index}`}
            label=''
            id={`kapasitas-${index}`}
            defaultValue={row.jumlah_bed}
            onChange={handleChange("kapasitas")}
            placeholder='Kapasitas'
          />
        </TableCell>
        <TableCell align='left'>
          <InputTextMaster
            name={`tersedia-${index}`}
            label=''
            defaultValue={row.bed_tersedia}
            id={`tersedia-${index}`}
            onChange={handleChange("tersedia")}
            placeholder='Tersedia'
          />
        </TableCell>
        <TableCell align='center'>
          <MasterButton
            name='UPDATE'
            color='green'
            type='button'
            disabled={disabled.state}
            onClick={() => handleClickUpdate(row)}
          />
        </TableCell>
      </TableRow>
    </>
  );
};

const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "kode",
    disablePadding: false,
    label: "KODE",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "jumlah_bed",
    disablePadding: false,
    label: "KAPASITAS",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "bed_tersedia",
    disablePadding: false,
    label: "TERSEDIA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "act",
    disablePadding: false,
    label: "ACT",
    align: "center",
    minWidth: "150px",
  },
];

export default ModalKetersediaanAplicare;
